const T_PREFIX = "clones";

export const clonesTrns = {
  title: `${T_PREFIX}.title`,
  addCloneButton: `${T_PREFIX}.add-clone-btn`,
};

export const inquirySuggestionBannerTrns = {
  title: `${T_PREFIX}.inquiry-suggestion-banner.title`,
  description: `${T_PREFIX}.inquiry-suggestion-banner.description`,
  addInquiryButton: `${T_PREFIX}.inquiry-suggestion-banner.add-inquiry-btn`,
};

export const noClonesBannerTrns = {
  title: `${T_PREFIX}.no-clones-banner.title`,
  description: `${T_PREFIX}.no-clones-banner.description`,
  addInquiryWithFiltersButton: `${T_PREFIX}.no-clones-banner.add-inquiry-with-filters-btn`,
};
